module.exports = __webpack_public_path__ + "img/15_26@2x.9b89be3d.png";